export default {
  agreed: 'Concordado',
  searchStatement: 'Termos de serviço de pesquisa',
  noData: 'Sem mais dados',
  starts: 'Estrela',
  searching: 'Pesquisando',
  searchService: 'Termos de serviço de pesquisa',
  filter: {
    performanceQuality: 'Qualidade de desempenho',
    comprehensiveExperienceScore: 'Pontuação de experiência abrangente',
    fourStartDown: 'Abaixo de 4 estrelas',
    certifiedFactory: 'Fábrica certificada',
    dayYield: 'Taxa de coleta de 24 horas',
    doubleDayYield: 'Taxa de coleta de 48 horas',
    performanceGuarantee: 'Garantia de desempenho',
    dayShipments: 'Envio no mesmo dia',
    strictSelect: 'Seleção rigorosa',
    disStrictSelect: 'Seleção rigorosa de distribuição',
    dayShip: 'Envio em 24 horas',
    doubleDayShip: 'Envio em 48 horas',
    sevenDayNoReason: '7 dias sem motivo',
    oneIssuing: 'Suporta venda única',
    onePostIssuing: 'Suporta frete grátis (frete grátis para venda única)',
    sevenDayNew: 'Novo em 7 dias',
    thirtyDayNew: 'Novo em 30 dias',
    wordStrictSelect: 'Seleção rigorosa global',
    isSelect: 'Seleção de estoque cross-border',
    priceSort: 'Ordenação por preço',
    compositeSort: 'Ordenação abrangente',
    up: 'Recolher',
    reset: 'Redefinir',
    moreFilters: 'Mais condições de filtro',
    bestMatch: 'Melhor correspondência',
    saleHighToLow: 'Vendas do maior para o menor',
    saleLowToHigh: 'Vendas do menor para o maior',
    priceHighToLow: 'Preço do maior para o menor',
    priceLowToHigh: 'Preço do menor para o maior',
    fastToSlow: 'Tempo de envio: Do mais rápido para o mais lento',
    slowToFast: 'Tempo de envio: Do mais lento para o mais rápido',
  },
}
